import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ITicketDefaultDocCategories } from "../../../../../models/ticket-default-doc-category";
import MainApiService from "../../../../../services/mainApi.service";

const TICKET_DEFAULT_DOC_CATEGORY_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketDefaultDocCategory/";
const ticketDefaultDocCategoryService =
  new MainApiService<ITicketDefaultDocCategories>(
    TICKET_DEFAULT_DOC_CATEGORY_ROUTE
  );

const translationPath = "page.settings.crm.ticketDefaultDocCategories.";

const TicketDefaultDocCategoriesPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { eI } = useParams();

  const columns: GridColDef<ITicketDefaultDocCategories>[] = [
    {
      field: "code",
      headerName: t(translationPath + "code") || "Code",
      maxWidth: 150,
    },
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (
    params: GridRowParams<ITicketDefaultDocCategories>
  ) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<ITicketDefaultDocCategories>
      showDefaultMacroFilters={false}
      service={ticketDefaultDocCategoryService}
      columns={columns}
      title={t(translationPath + "ticket_default_doc_categories")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      disableFilterParams
      backButton
      backButtonUrl={`/e/${eI}/dashboard/settings`}
      searchInputPlaceHolder={
        t(translationPath + "search") ||
        "Search for a standard guidance protocol category"
      }
      addButtonLabel={
        t(translationPath + "add_ticket_default_doc_category") ||
        "Add standard guidance protocol category"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default TicketDefaultDocCategoriesPage;
